import { useMemo, type VoidFunctionComponent } from 'react';

import { window } from '../../globals';
import CallToAction from '../CallToAction';
import PageHeadingBreadcrumbs from '../generic/PageHeadingBreadcrumbs';
import TeamSelectionMenu from '../shared/teams/TeamSelectionMenu';

/**
 * The top "call to action" header section for the global reports page.
 */
const ReportsCallToAction: VoidFunctionComponent = () => {
  //  useMemo helps us avoid passing down a new object on every re-render
  const crumbs = useMemo(() => ([
    {
      text: window.user?.organization?.title ?? 'Organization',
      to: '/projects',
    },
    {
      text: 'Reports',
    },
    {
      content: <TeamSelectionMenu />,
    },
  // eslint-disable-next-line react-hooks/exhaustive-deps -- Only re-render if the organization title changes
  ]), [window.user?.organization?.title]);

  return (
    <CallToAction>
      <PageHeadingBreadcrumbs crumbs={crumbs} />
    </CallToAction>
  );
};

export default ReportsCallToAction;
